export enum IRedemptionState {
  REDEEMABLE = 'redeemable',
  REDEEMED = 'redeemed',
  EXPIRED = 'expired',
}
